<div class="institution-summary">
  <div class="institution-summary__header">
    <h2 class="institution-summary__name-title" data-pw="institution_name_title" data-qa="institution_name_title">
      {{ institution()?.name }}
    </h2>
    @if (!isEditing() && institution()) {
      <button mat-button type="button" class="institution-summary__edit" (click)="onEdit()">
        <mat-icon class="mat-action-icon" svgIcon="k12-edit"></mat-icon>
        <span>Edit</span>
      </button>
    }
  </div>
  <div class="institution-summary__card">
    <div class="institution-summary__header">
      <h3>Institution Summary</h3>
    </div>

    @if (!isEditing()) {
      <div class="institution-summary__grid">
        <div class="institution-summary__item">
          <span class="institution-summary__section-title">Institution Information</span>
          <div>
            <div class="institution-summary__label">Address:</div>
            <div class="institution-summary__value">
              <!-- address is a plain string getter, so Angular auto-sanitizes this binding -->
              <span [innerHTML]="address"></span>
            </div>
            <div class="institution-summary__label mt-2">County:</div>
            <div class="institution-summary__value">
              <span>{{ institution()?.county || '-' }}</span>
            </div>
          </div>
        </div>

        <div class="institution-summary__item">
          <span class="institution-summary__section-title">HDMA Information</span>
          <div>
            <div class="institution-summary__label">HDMA Name:</div>
            <div class="institution-summary__value">
              <span>{{ hdmaName }}</span>
            </div>
            <div class="institution-summary__label mt-2">Email:</div>
            <div class="institution-summary__value">
              <span>{{ institution()?.hdma?.email || '-' }}</span>
            </div>
            <div class="institution-summary__label mt-2">Phone:</div>
            <div class="institution-summary__value">
              <span>{{ hdmaPhone }}</span>
            </div>
          </div>
        </div>

        <div class="institution-summary__item">
          <span class="institution-summary__section-title">Other Details</span>
          <div>
            <div class="institution-summary__label">FEIN:</div>
            <div class="institution-summary__value">
              <span>{{ institution()?.federalEmployerID || '-' }}</span>
            </div>
            <div class="institution-summary__label mt-2">Fiscal Year End Date:</div>
            <div class="institution-summary__value">
              <span>{{
                institution()?.fiscalYearEndDate ? (institution()!.fiscalYearEndDate | date: 'MMMM d') || '-' : '-'
              }}</span>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <form class="institution-summary__form" [formGroup]="form" (ngSubmit)="onSave()">
        <div class="institution-summary__form-section">
          <h5 class="institution-summary__section-title">Institution Information</h5>
          <div class="institution-summary__fields">
            <div class="institution-summary__field half-width">
              <div class="user-record-field-wrapper">
                <label for="address1" class="field-label">Street Address</label>
                <mat-form-field class="institution-fields">
                  <input
                    id="address1"
                    matInput
                    type="text"
                    placeholder="123 Main Street"
                    class="user-record-field-input"
                    formControlName="address1" />
                  @if (form.get('address1')?.invalid && form.get('address1')?.touched) {
                    <mat-error>Street Address is required</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="institution-summary__field half-width">
              <div class="user-record-field-wrapper">
                <label for="address2" class="field-label">Address Line 2</label>
                <mat-form-field class="institution-fields">
                  <input
                    id="address2"
                    matInput
                    type="text"
                    placeholder="Suite 100"
                    class="user-record-field-input"
                    formControlName="address2" />
                </mat-form-field>
              </div>
            </div>

            <div class="institution-summary__field half-width">
              <div class="user-record-field-wrapper">
                <label for="city" class="field-label">City</label>
                <mat-form-field class="institution-fields">
                  <input
                    id="city"
                    matInput
                    type="text"
                    placeholder="City"
                    class="user-record-field-input"
                    formControlName="city" />
                  @if (form.get('city')?.invalid && form.get('city')?.touched) {
                    <mat-error>City is required</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="institution-summary__field half-width">
              <div class="user-record-field-wrapper">
                <label for="state" class="field-label">State</label>
                <mat-form-field class="institution-fields">
                  <input
                    id="state"
                    matInput
                    type="text"
                    placeholder="State"
                    class="user-record-field-input"
                    formControlName="state"
                    [matAutocomplete]="stateAuto" />
                  <mat-autocomplete #stateAuto="matAutocomplete" [displayWith]="displayStateName">
                    @for (state of filteredStates | async; track state.code) {
                      <mat-option [value]="state">{{ state.name }}</mat-option>
                    }
                  </mat-autocomplete>
                  @if (form.get('state')?.invalid && form.get('state')?.touched) {
                    <mat-error>State is required</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="institution-summary__field quarter-width">
              <div class="user-record-field-wrapper">
                <label for="zip" class="field-label">Zip Code</label>
                <mat-form-field class="institution-fields">
                  <input
                    id="zip"
                    matInput
                    type="text"
                    maxlength="5"
                    placeholder="12345"
                    class="user-record-field-input"
                    formControlName="zip" />
                  @if (form.get('zip')?.invalid && form.get('zip')?.touched) {
                    <mat-error>Zip Code is required</mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            @if (isNorthCarolina) {
              <div class="institution-summary__field quarter-width">
                <div class="user-record-field-wrapper">
                  <label for="county" class="field-label">County</label>
                  <mat-form-field class="institution-fields">
                    <input
                      id="county"
                      matInput
                      type="text"
                      placeholder="County"
                      class="user-record-field-input"
                      formControlName="county"
                      [matAutocomplete]="countyAuto" />
                    <mat-autocomplete #countyAuto="matAutocomplete">
                      @for (county of filteredCounties | async; track county.id) {
                        <mat-option [value]="county.name">{{ county.name }}</mat-option>
                      }
                    </mat-autocomplete>
                    @if (form.get('county')?.invalid && form.get('county')?.touched) {
                      <mat-error>County is required</mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="institution-summary__form-section">
          <h5 class="institution-summary__section-title">HDMA Information</h5>
          <p class="institution-summary__hint">HDMA details are managed from the Contacts section below.</p>
          <div class="institution-summary__readonly-grid">
            <div>
              <div class="institution-summary__label">HDMA Name:</div>
              <div class="institution-summary__value">{{ hdmaName }}</div>
            </div>
            <div>
              <div class="institution-summary__label">Email:</div>
              <div class="institution-summary__value">{{ institution()?.hdma?.email || '-' }}</div>
            </div>
            <div>
              <div class="institution-summary__label">Phone:</div>
              <div class="institution-summary__value">{{ hdmaPhone }}</div>
            </div>
          </div>
        </div>

        <div class="institution-summary__form-section">
          <h5 class="institution-summary__section-title">Other Details</h5>
          <div class="institution-summary__fields">
            <div class="institution-summary__field half-width">
              <div class="user-record-field-wrapper">
                <label for="federalEmployerID" class="field-label">FEIN</label>
                <mat-form-field class="institution-fields">
                  <input
                    id="federalEmployerID"
                    matInput
                    type="text"
                    maxlength="10"
                    placeholder="00-0000000"
                    class="user-record-field-input"
                    formControlName="federalEmployerID"
                    (input)="formatFein($event)" />
                  @if (form.get('federalEmployerID')?.touched) {
                    @if (form.get('federalEmployerID')?.hasError('required')) {
                      <mat-error>FEIN is required</mat-error>
                    } @else if (form.get('federalEmployerID')?.invalid) {
                      <mat-error>FEIN must be in format 00-0000000</mat-error>
                    }
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="institution-summary__field half-width">
              <div class="user-record-field-wrapper">
                <label for="fiscalYearEndDate" class="field-label">Fiscal Year End Date</label>
                <mat-form-field class="institution-fields">
                  <div class="user-record-datepicker-wrapper">
                    <input
                      id="fiscalYearEndDate"
                      matInput
                      [matDatepicker]="fiscalYearPicker"
                      placeholder="Select fiscal year end date"
                      class="user-record-field-input"
                      formControlName="fiscalYearEndDate"
                      readonly
                      (click)="fiscalYearPicker.open()" />
                    <mat-datepicker-toggle matIconSuffix [for]="fiscalYearPicker"></mat-datepicker-toggle>
                    <mat-datepicker #fiscalYearPicker></mat-datepicker>
                  </div>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="institution-summary__actions">
          <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-flat-button color="primary" type="submit">Save</button>
        </div>
      </form>
    }
  </div>
</div>
